import { useEffect, useState } from 'react';
import SearchContainer from '../../components/SearchContainer/SearchContainer';
import SearchInput from '../../components/SearchInput/SearchInput';
import './NotifierConfigurations.css';
import Container from '../../components/Container/Container';
import NotificationsService from '../../services/NotificationsService';
import { NotificationCategoryNames } from '../../constants/notifications.constants';
import Button from '../../components/Button/Button';
import { TbBellCog } from 'react-icons/tb';

export function NotifierConfigurations() {
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const [notificationCategories, setNotificationCategories] = useState();

	async function loadNotificationCategories() {
		const response = await NotificationsService.listCategoriesTargets();
		if (response.data) {
			const groups = {};
			response.data.forEach(element => {
				let categoryData = groups[element.categoryId] ?? {};
				categoryData.name = element.categoryName;
				categoryData.id = element.categoryId;
				categoryData.targets = [
					...categoryData.targets ?? [],
					{
						targetTypeId: element.targetTypeId,
						targetTypeName: element.targetTypeName,
						editable: element.editable,
						enabled: element.enabled,
						authorityPath: element.authorityPath ?? null,
					}
				];
				groups[element.categoryId] = categoryData;
			});
			setNotificationCategories(groups);
		}
	}

	useEffect(() => {
		loadNotificationCategories();
	}, []);

	function updateTarget(categoryId, targetTypeId, checked) {
		setNotificationCategories(prevGroups => {
			let newState = { ...prevGroups };
			let category = newState[categoryId];
			let targets = category.targets.map(target => {
				if (target.targetTypeId === targetTypeId) {
					return {
						...target,
						enabled: checked,
					}
				}
				return target;
			});
			return {
				...prevGroups,
				[categoryId]: {
					...category,
					targets,
				},
			}
		});
	}

	async function saveConfig() {
		const payload = [];
		Object.entries(notificationCategories)?.map(([key, value], idx) => {
			value.targets.filter(target => target.editable).forEach(target => {
				payload.push({
					categoryId: value.id,
					targetTypeId: target.targetTypeId,
					enabled: target.enabled,
				});
			});
		});
		await NotificationsService.saveCategoriesTargets({ data: payload });
	}

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<TbBellCog size={20} />}
					title="Configuração de notificações"
					hideAddButton={true}
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<div className='list-configs'>
						{notificationCategories && Object.entries(notificationCategories)?.filter(([_, value]) => searchText === "" || NotificationCategoryNames[Number(value.id)].toLowerCase().includes(searchText.toLowerCase())).map(([key, value], idx) => (
							<div key={idx} className='notification-category-config-item'>
								<div className='title-box'>
									<h2>
										{NotificationCategoryNames[Number(value.id)]}
									</h2>
								</div>
								<div className='targets-box'>
									{value.targets.map(target => (
										<label htmlFor={`target-${value.id}-${target.targetTypeId}`} data-disabled={!target.editable}>
											<input type='checkbox' checked={target.enabled} onChange={e => updateTarget(value.id, target.targetTypeId, e.target.checked)} disabled={!target.editable} id={`target-${value.id}-${target.targetTypeId}`} />
											<span>{target.targetTypeName}</span>
										</label>
									))}
								</div>
							</div>
						))}
					</div>
					<div className="form-buttons" style={{ display: 'flex', justifyContent: 'end', marginTop: '20px', marginBottom: '35px' }}>
						<Button
							className={"button-blue"}
							label={"Salvar"}
							type={"button"}
							onClick={e => saveConfig()}
						/>
					</div>
				</Container>
			</div>
		</div>
	);
}